import {combineReducers} from 'redux'
import UserReducer from "./user.reducer";
import AircraftReducer from "./aircraft.reducer";
import PaymentReducer from "./payment.reducer";
import AuthReducer from "./auth.reducer";

const rootReducer = combineReducers({
  user: UserReducer,
  aircraft: AircraftReducer,
  payment: PaymentReducer,
  auth : AuthReducer
});

export default rootReducer
